import dayTradeReport from '@/views/report/day-trade-report';
import positionReport from '@/views/report/position-report';
import bBookReport from '@/views/report/b-book-report';
import clientReport from '@/views/report/client-report';
import monitorAccountsReport from '@/views/report/monitor-accounts-report';
import autoPositionReport from '@/views/report/auto-position-report';
import autoUpdateLeverage from '@/views/report/auto-update-leverage';
import chargeDividends from '@/views/report/charge-dividends';
import annualInterestBonus from '@/views/report/annual-interest-bonus';

const reportRouters = [
    { path: '/dayTradeReport', component: dayTradeReport },
    { path: '/positionReport', component: positionReport },
    { path: '/bBookReport', component: bBookReport },
    { path: '/clientReport', component: clientReport },
    { path: '/monitorAccountsReport', component: monitorAccountsReport },
    { path: '/autoPositionReport', component: autoPositionReport },
    { path: '/autoUpdateLeverage', component: autoUpdateLeverage },
    { path: '/chargeDividends', component: chargeDividends },
    { path: '/annualInterestBonus', component: annualInterestBonus },
]

export default reportRouters;


// WEBPACK FOOTER //
// ./src/router/report/index.js